import React from 'react';
import { Link } from 'react-router-dom';
import { useResponsive } from '../hooks/useResponsive';

const PrivacyPolicy = () => {
  const viewport = useResponsive();

  const styles = {
    container: {
      maxWidth: '800px',
      margin: '0 auto',
      padding: viewport.isMobile ? 'var(--space-lg) var(--space-md)' : '40px 20px',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      minHeight: '100vh'
    },
    header: {
      display: 'flex',
      flexDirection: viewport.isMobile ? 'column' : 'row',
      justifyContent: viewport.isMobile ? 'flex-start' : 'space-between',
      alignItems: viewport.isMobile ? 'flex-start' : 'center',
      marginBottom: viewport.isMobile ? 'var(--space-lg)' : '32px',
      gap: viewport.isMobile ? 'var(--space-md)' : '0'
    },
    title: {
      fontSize: viewport.isMobile ? 'var(--text-xl)' : 'var(--text-2xl)',
      color: '#3B82F6',
      margin: 0
    },
    backLink: {
      color: '#3B82F6',
      textDecoration: 'none',
      padding: viewport.isMobile ? '12px 20px' : '8px 16px',
      border: '1px solid #3B82F6',
      borderRadius: '4px',
      fontSize: viewport.isMobile ? 'var(--text-base)' : '14px',
      minHeight: '44px',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    content: {
      lineHeight: viewport.isMobile ? '1.8' : '1.6',
      color: '#374151',
      fontSize: viewport.isMobile ? 'var(--text-base)' : '16px'
    },
    heading: {
      fontSize: viewport.isMobile ? 'var(--text-lg)' : '22px',
      marginTop: viewport.isMobile ? 'var(--space-lg)' : '28px',
      marginBottom: viewport.isMobile ? 'var(--space-sm)' : '16px',
      color: '#1F2937'
    },
    paragraph: {
      marginBottom: viewport.isMobile ? 'var(--space-md)' : '16px'
    },
    list: {
      marginBottom: viewport.isMobile ? 'var(--space-md)' : '16px',
      paddingLeft: viewport.isMobile ? 'var(--space-lg)' : '24px'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>
          Skip Tracker Privacy Policy
        </h1>
        <Link to="/" style={styles.backLink}>
          Back to Login
        </Link>
      </div>

      <div style={styles.content}>
        <p style={styles.paragraph}>Last Updated: [Current Date]</p>

        <h2 style={styles.heading}>Introduction</h2>
        <p style={styles.paragraph}>
          Skip Tracker ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Skip Tracker mobile application and website (collectively, the "Service").
        </p>

        <h2 style={styles.heading}>Information We Collect</h2>
        <p style={styles.paragraph}>We may collect information about you in various ways, including:</p>
        <ul style={styles.list}>
          <li style={styles.paragraph}>Information you provide when you register for an account</li>
          <li style={styles.paragraph}>Information about your use of the Service</li>
          <li style={styles.paragraph}>Information about your device and internet connection</li>
          <li style={styles.paragraph}>Location information when you use our mapping features</li>
        </ul>

        <h2 style={styles.heading}>How We Use Your Information</h2>
        <p style={styles.paragraph}>We may use the information we collect for various purposes, including to:</p>
        <ul style={styles.list}>
          <li style={styles.paragraph}>Provide, maintain, and improve our Service</li>
          <li style={styles.paragraph}>Process and complete transactions</li>
          <li style={styles.paragraph}>Send you technical notices and support messages</li>
          <li style={styles.paragraph}>Respond to your comments and questions</li>
          <li style={styles.paragraph}>Develop new products and services</li>
          <li style={styles.paragraph}>Monitor and analyze trends and usage</li>
        </ul>

        <h2 style={styles.heading}>Sharing of Your Information</h2>
        <p style={styles.paragraph}>
          We may share your information with third parties in certain situations, including:
        </p>
        <ul style={styles.list}>
          <li style={styles.paragraph}>With service providers who perform services on our behalf</li>
          <li style={styles.paragraph}>To comply with legal obligations</li>
          <li style={styles.paragraph}>To protect and defend our rights and property</li>
          <li style={styles.paragraph}>With your consent or at your direction</li>
        </ul>

        <h2 style={styles.heading}>Data Security</h2>
        <p style={styles.paragraph}>
          We use reasonable measures to help protect your personal information from loss, theft, misuse, unauthorized access, disclosure, alteration, and destruction.
        </p>

        <h2 style={styles.heading}>Your Choices</h2>
        <p style={styles.paragraph}>
          You can control certain information we collect by adjusting your device settings or contacting us directly.
        </p>

        <h2 style={styles.heading}>Changes to This Privacy Policy</h2>
        <p style={styles.paragraph}>
          We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
        </p>

        <h2 style={styles.heading}>Contact Us</h2>
        <p style={styles.paragraph}>
          If you have any questions or concerns about this Privacy Policy, please contact us at: [Your Contact Information]
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;